var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1006 211",
    style: {
      enableBackground: "new 0 0 1006 211"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000107561477092078964340000006893166334073755548_);}\r\n\t.st2{fill:url(#SVGID_00000018931169414509343250000000526767388330661010_);}\r\n\t.st3{fill:url(#SVGID_00000147221099086102834250000008812844849814207677_);}\r\n\t.st4{fill:url(#SVGID_00000049936349100653365070000000630702123192821434_);}\r\n\t.st5{fill:url(#SVGID_00000042011950485750277970000012826109345925013432_);}\r\n\t.st6{fill:url(#SVGID_00000106858152721982025400000009075144127896283577_);}\r\n\t.st7{fill:url(#SVGID_00000031930299077142730330000017865811244940711866_);}\r\n\t.st8{fill:url(#SVGID_00000091714553899854045330000015700429182741560970_);}\r\n\t.st9{fill:url(#SVGID_00000037659985450432533610000008200339102276679335_);}\r\n\t.st10{fill:url(#SVGID_00000075128684860150343660000018219155757287808173_);}\r\n\t.st11{fill:url(#SVGID_00000151544250272714699560000012421021944547208349_);}\r\n\t.st12{fill:url(#SVGID_00000114064856052370594680000012952172896266562727_);}\r\n\t.st13{fill:#AAAAAA;}\r\n\t.st14{fill:url(#SVGID_00000024682844173614925230000000018854104027752095_);}\r\n\t.st15{fill:url(#SVGID_00000112619493441741698800000015196331688857842878_);}\r\n\t.st16{fill:url(#SVGID_00000044862753451958242020000002128082000485185937_);}\r\n\t.st17{fill:url(#SVGID_00000163756946490553148510000000536429371641128114_);}\r\n\t.st18{fill:url(#SVGID_00000060025072235497368890000010876610326595345324_);}\r\n\t.st19{fill:url(#SVGID_00000080195100307463219960000004771313337088743046_);}\r\n\t.st20{fill:#474747;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.1017,
    y1: 132.8015,
    x2: 327.6811,
    y2: 106.4389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B1464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1207,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3214,
    style: {
      stopColor: "#153778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5773,
    style: {
      stopColor: "#0E6090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8756,
    style: {
      stopColor: "#0499B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.2,133.9V16H365v117.9c0,42.7-19.9,64.1-59.6,64.1h-3.7c-24.8,0-48.4-4.3-70.8-12.8v-38.5 c27.3,8.5,50.9,12.8,70.8,12.8h3.7C325.3,159.5,335.2,151,335.2,133.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044864546790717402210000007052271957947515276_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.0439,
    y1: 44.1209,
    x2: 331.5289,
    y2: 160.0679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044864546790717402210000007052271957947515276_)"
    },
    d: "M413.1,16c46.6,0,69.9,16.9,69.9,50.6v6.3 c0,13.1-3.5,23.6-10.5,31.6c7,8,10.5,18.5,10.5,31.6v6.3c0,33.7-23.3,50.6-69.9,50.6h-77.7V16H413.1z M366.5,53.9v31.6h46.6 c25.9,0,38.8-4.2,38.8-12.6v-6.3c0-8.4-12.9-12.6-38.8-12.6H366.5z M366.5,123.5v31.6h46.6c25.9,0,38.8-4.2,38.8-12.6v-6.3 c0-8.4-12.9-12.6-38.8-12.6H366.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101782855936553619140000001538808622843984548_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.5142,
    y1: 78.0047,
    x2: 265.2035,
    y2: 81.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 76,
    style: {
      fill: "url(#SVGID_00000101782855936553619140000001538808622843984548_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121992756030037050470000005525395950648957845_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.5142,
    y1: 60.0047,
    x2: 283.2035,
    y2: 63.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 58,
    style: {
      fill: "url(#SVGID_00000121992756030037050470000005525395950648957845_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003785940522303584460000009765640450498415272_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.5142,
    y1: 70.0047,
    x2: 291.2035,
    y2: 73.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 68,
    style: {
      fill: "url(#SVGID_00000003785940522303584460000009765640450498415272_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028296713797114748120000018006706393422320768_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.5142,
    y1: 69.0047,
    x2: 274.2035,
    y2: 72.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 67,
    style: {
      fill: "url(#SVGID_00000028296713797114748120000018006706393422320768_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143583770548153636250000004964801513470550181_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.5142,
    y1: 51.0047,
    x2: 293.2035,
    y2: 54.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 49,
    style: {
      fill: "url(#SVGID_00000143583770548153636250000004964801513470550181_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152252496727162518660000007496252975817602704_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.5142,
    y1: 42.0047,
    x2: 302.2035,
    y2: 45.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 40,
    style: {
      fill: "url(#SVGID_00000152252496727162518660000007496252975817602704_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174593459132369043980000006168563051832254354_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.5142,
    y1: 61.0047,
    x2: 300.2035,
    y2: 64.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 59,
    style: {
      fill: "url(#SVGID_00000174593459132369043980000006168563051832254354_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152242133620840632570000018420048533878733442_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.5142,
    y1: 79.0047,
    x2: 282.2035,
    y2: 82.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 77,
    style: {
      fill: "url(#SVGID_00000152242133620840632570000018420048533878733442_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046337792434212172450000006499819506385284507_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.5142,
    y1: 80.0047,
    x2: 300.2035,
    y2: 83.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 78,
    style: {
      fill: "url(#SVGID_00000046337792434212172450000006499819506385284507_)"
    },
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114759471310634465320000011309284991731063473_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.8775,
    y1: 153.8495,
    x2: 449.3515,
    y2: 244.9229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#191D69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    style: {
      stopColor: "#17266E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    style: {
      stopColor: "#13407D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    style: {
      stopColor: "#0C6995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9533,
    style: {
      stopColor: "#02A2B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#01AABA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114759471310634465320000011309284991731063473_)"
    },
    d: "M250.9,145V183c0.6,0.2,1.3,0.4,1.9,0.6 l17.5-34C264,148.2,257.6,146.7,250.9,145z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033339397814445104010000009360888228566470052_",
    gradientUnits: "userSpaceOnUse",
    x1: -3341.1565,
    y1: 104.53,
    x2: 763.9187,
    y2: 104.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033339397814445104010000009360888228566470052_)"
    },
    d: "M284,89c-2.6-0.7-3.9-1.4-7-2 c-7.7-1.5-15,0-21.5,2.8l-33.7,65.3h-2.5l-21.5-41.7l41.1-79.7V16h-36.5l-27.4,53.1L147.5,16H111v17.7l41,79.7l-21.5,41.7H128 L56.3,16H19.8v17.7l82.1,159.4h54.8l18.2-35.4l18.2,35.4h54.8l4.9-9.6l17.5-34l31.8-61.7C294.5,90.3,288.5,90.1,284,89z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M521,193L521,193c-3.3,0-6-2.7-6-6V28c0-3.3,2.7-6,6-6l0,0c3.3,0,6,2.7,6,6v159C527,190.3,524.3,193,521,193z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117666132020976187320000015810886381033515922_",
    gradientUnits: "userSpaceOnUse",
    x1: 543.9531,
    y1: 75.9587,
    x2: 646.8232,
    y2: 75.9587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117666132020976187320000015810886381033515922_)"
    },
    d: "M564.6,35.3c1.8,8.2,3.7,16.5,5.5,25 c1.8,8.4,3.6,16.8,5.4,25.1c1.8-8.3,3.7-16.6,5.6-25.1c1.9-8.4,3.7-16.8,5.4-25c3.1,0,6.3,0,9.4,0c3.2,0,6.3,0,9.4,0 c1.9,8.2,3.8,16.5,5.7,24.9c1.9,8.4,3.8,16.7,5.7,25c1.8-8.3,3.6-16.6,5.4-25s3.6-16.6,5.3-24.9c3.2,0,6.4,0,9.6,0s6.4,0,9.6,0 c-2.9,13.4-5.9,26.9-8.8,40.6c-2.9,13.7-5.9,27.2-8.8,40.6c-3.9,0-7.9,0-11.9,0c-4,0-8,0-12,0c-1.7-7.4-3.4-14.9-5.1-22.4 c-1.8-7.5-3.5-15-5.1-22.4c-1.6,7.4-3.2,14.9-4.9,22.4c-1.7,7.5-3.3,15-4.9,22.4c-3.9,0-7.8,0-11.8,0s-7.9,0-11.8,0 c-2.9-13.4-5.9-26.9-8.8-40.6c-2.9-13.7-5.9-27.2-8.8-40.6c3.4,0,6.9,0,10.3,0S561.2,35.3,564.6,35.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078762875822211050470000007085670923042963076_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.3799,
    y1: 75.9587,
    x2: 705.127,
    y2: 75.9587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078762875822211050470000007085670923042963076_)"
    },
    d: "M656.4,116.6c0-13.4,0-26.9,0-40.6 c0-13.7,0-27.2,0-40.6c8,0,16.2,0,24.4,0c8.2,0,16.3,0,24.4,0c0,3,0,6.1,0,9.3c0,3.2,0,6.3,0,9.3c-4.6,0-9.3,0-13.9,0 c-4.7,0-9.3,0-13.9,0c0,2,0,4,0,5.9c0,2,0,3.9,0,5.9c4.2,0,8.5,0,12.8,0c4.3,0,8.5,0,12.7,0c0,2.9,0,5.9,0,9c0,3,0,6.1,0,9.1 c-4.1,0-8.4,0-12.7,0c-4.3,0-8.6,0-12.8,0c0,2.3,0,4.7,0,7s0,4.7,0,7c4.6,0,9.3,0,13.9,0c4.7,0,9.3,0,13.9,0c0,3,0,6.1,0,9.3 c0,3.2,0,6.3,0,9.3c-8,0-16.2,0-24.4,0C672.5,116.6,664.4,116.6,656.4,116.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108289861842016419170000018130406753229568690_",
    gradientUnits: "userSpaceOnUse",
    x1: 719.4639,
    y1: 75.9587,
    x2: 779.3223,
    y2: 75.9587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108289861842016419170000018130406753229568690_)"
    },
    d: "M719.5,116.6c0-13.4,0-26.9,0-40.6 c0-13.7,0-27.2,0-40.6c4.9,0,9.9,0,14.9,0c5,0,9.9,0,14.8,0c5.5,0,10.3,1,14.5,2.9c4.1,2,7.4,4.7,9.7,8.1c2.3,3.5,3.5,7.5,3.5,12.2 c0,3.3-0.6,6.4-1.9,9.1c-1.3,2.7-3.2,5-5.7,6.8c3.3,2,5.9,4.6,7.6,7.7c1.8,3.1,2.6,6.6,2.6,10.5c0,4.8-1.2,9-3.6,12.5 c-2.4,3.6-5.8,6.4-10.2,8.4c-4.3,2-9.4,3-15.2,3c-5.1,0-10.2,0-15.4,0C729.7,116.6,724.6,116.6,719.5,116.6z M755.8,60.7 c0-2.1-0.6-3.8-1.9-5.1c-1.3-1.3-2.9-2-5-2c-1.4,0-2.9,0-4.4,0c-1.5,0-2.9,0-4.4,0c0,2.2,0,4.5,0,6.9c0,2.4,0,4.7,0,7 c1.4,0,2.9,0,4.4,0c1.5,0,2.9,0,4.4,0c2.1,0,3.7-0.6,5-1.9C755.1,64.4,755.8,62.7,755.8,60.7z M758.4,90.8c0-2.2-0.7-4-2.2-5.3 c-1.5-1.3-3.5-2-6-2c-1.7,0-3.3,0-5,0c-1.7,0-3.3,0-5,0c0,2.5,0,4.9,0,7.4c0,2.5,0,4.9,0,7.4c1.7,0,3.3,0,5,0c1.7,0,3.3,0,5,0 c2.5,0,4.6-0.7,6-2C757.7,94.9,758.4,93.1,758.4,90.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108268646706386188840000004280471315158996878_",
    gradientUnits: "userSpaceOnUse",
    x1: 785.2949,
    y1: 76.6567,
    x2: 828.1875,
    y2: 76.6567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108268646706386188840000004280471315158996878_)"
    },
    d: "M828.2,88.5c0,5.5-0.8,10.4-2.3,14.6 c-1.6,4.2-4,7.6-7.5,10.1c-3.4,2.5-7.8,4-13.3,4.6c-5.4,0.6-12,0-19.8-1.8c0-3.3,0-6.6,0-9.9c0-3.3,0-6.6,0-9.9 c7.6,2.2,13.2,2.6,16.7,1.5c3.5-1.2,5.3-4.2,5.3-9.1c0-8.8,0-17.6,0-26.6c0-9,0-17.8,0-26.6c3.5,0,7,0,10.5,0c3.5,0,7,0,10.4,0 c0,8.8,0,17.6,0,26.6C828.2,70.9,828.2,79.7,828.2,88.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013171726716817140590000016623350222702195647_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.4619,
    y1: 75.9587,
    x2: 918.9893,
    y2: 75.9587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013171726716817140590000016623350222702195647_)"
    },
    d: "M878.7,118.5c-5.8,0-11.2-1.1-16.1-3.2 c-4.9-2.1-9.2-5.1-12.8-8.9c-3.6-3.8-6.4-8.3-8.4-13.6c-2-5.2-3-10.9-3-17c0-6.1,1-11.8,3-17c2-5.2,4.8-9.7,8.4-13.4 c3.6-3.8,7.8-6.7,12.8-8.8c4.9-2.1,10.3-3.2,16.1-3.2c5.8,0,11.2,1.1,16.1,3.2c4.9,2.1,9.2,5.1,12.8,8.8c3.6,3.8,6.4,8.3,8.4,13.4 c2,5.2,3,10.8,3,17c0,6.1-1,11.8-3,17c-2,5.2-4.8,9.7-8.4,13.6c-3.6,3.8-7.9,6.8-12.8,8.9C889.9,117.4,884.5,118.5,878.7,118.5z  M878.7,99.1c3.9,0,7.2-1,10-2.9c2.8-2,5-4.7,6.5-8.2c1.6-3.5,2.3-7.6,2.3-12.2c0-4.6-0.8-8.6-2.3-12.1c-1.6-3.4-3.7-6.1-6.5-8.1 c-2.8-2-6.1-2.9-10-2.9c-3.8,0-7.2,1-10,2.9c-2.8,1.9-5,4.6-6.6,8.1c-1.6,3.5-2.3,7.5-2.3,12.1c0,4.6,0.8,8.7,2.3,12.2 c1.6,3.5,3.7,6.2,6.6,8.2C871.6,98.2,874.9,99.1,878.7,99.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001648719672091053170000018293238054935836545_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.457,
    y1: 75.9587,
    x2: 990.3154,
    y2: 75.9587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F84AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#0C8DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#04A7BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#00B2BF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001648719672091053170000018293238054935836545_)"
    },
    d: "M930.5,116.6c0-13.4,0-26.9,0-40.6 c0-13.7,0-27.2,0-40.6c4.9,0,9.9,0,14.9,0c5,0,9.9,0,14.8,0c5.5,0,10.3,1,14.5,2.9c4.1,2,7.4,4.7,9.7,8.1c2.3,3.5,3.5,7.5,3.5,12.2 c0,3.3-0.6,6.4-1.9,9.1c-1.3,2.7-3.2,5-5.7,6.8c3.3,2,5.9,4.6,7.6,7.7c1.8,3.1,2.6,6.6,2.6,10.5c0,4.8-1.2,9-3.6,12.5 c-2.4,3.6-5.8,6.4-10.2,8.4c-4.3,2-9.4,3-15.2,3c-5.1,0-10.2,0-15.4,0C940.7,116.6,935.6,116.6,930.5,116.6z M966.8,60.7 c0-2.1-0.6-3.8-1.9-5.1c-1.3-1.3-2.9-2-5-2c-1.4,0-2.9,0-4.4,0c-1.5,0-2.9,0-4.4,0c0,2.2,0,4.5,0,6.9c0,2.4,0,4.7,0,7 c1.4,0,2.9,0,4.4,0c1.5,0,2.9,0,4.4,0c2.1,0,3.7-0.6,5-1.9C966.1,64.4,966.8,62.7,966.8,60.7z M969.4,90.8c0-2.2-0.7-4-2.2-5.3 c-1.5-1.3-3.5-2-6-2c-1.7,0-3.3,0-5,0c-1.7,0-3.3,0-5,0c0,2.5,0,4.9,0,7.4c0,2.5,0,4.9,0,7.4c1.7,0,3.3,0,5,0c1.7,0,3.3,0,5,0 c2.5,0,4.6-0.7,6-2C968.7,94.9,969.4,93.1,969.4,90.8z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M549.3,142.4h24v4.5h-24V142.4z M558.9,145.2h4.8v31.3h-4.8V145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M586.3,142.4h4.8v34.1h-4.8V142.4z M588.7,142.4h19.6v4.5h-19.6V142.4z M588.7,157.3h17v4.5h-17V157.3z  M588.7,171.9h19.6v4.5h-19.6V171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M629.2,175.2c-1.8-1-3.2-2.5-4.2-4.5s-1.5-4.1-1.5-6.7v-9.4c0-2.5,0.5-4.8,1.5-6.7s2.4-3.4,4.2-4.5 s3.9-1.6,6.2-1.6c2,0,3.8,0.4,5.4,1.3s3,2,4.1,3.6s1.8,3.3,2.2,5.3h-4.9c-0.3-1.1-0.8-2-1.5-2.8s-1.5-1.5-2.4-1.9 s-1.9-0.7-2.9-0.7c-1.4,0-2.6,0.3-3.7,1s-1.9,1.6-2.4,2.8s-0.9,2.6-0.9,4.2v9.4c0,1.6,0.3,3,0.9,4.2s1.4,2.2,2.4,2.8s2.3,1,3.7,1 c1,0,2-0.2,2.9-0.6s1.7-1,2.4-1.9s1.2-1.8,1.5-3h4.9c-0.4,2-1.1,3.8-2.2,5.3s-2.5,2.7-4.1,3.6s-3.4,1.3-5.4,1.3 C633.1,176.8,631,176.3,629.2,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M663.3,142.4h4.8v34.1h-4.8V142.4z M666.2,157.4h18.9v4.5h-18.9V157.4z M682.6,142.4h4.8v34.1h-4.8V142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M705.1,142.4h4.3l16.7,26.3l-0.6,0.6v-27h4.7v34.1h-4.4l-16.6-25.9l0.6-0.6v26.6h-4.7V142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M753,175.3c-1.8-1-3.2-2.5-4.2-4.4s-1.5-4.1-1.5-6.6v-9.7c0-2.5,0.5-4.7,1.5-6.6s2.4-3.4,4.2-4.4 s3.9-1.6,6.3-1.6s4.5,0.5,6.3,1.6s3.2,2.5,4.2,4.4s1.5,4.1,1.5,6.6v9.7c0,2.5-0.5,4.7-1.5,6.6s-2.4,3.4-4.2,4.4s-3.9,1.6-6.3,1.6 S754.8,176.3,753,175.3z M763,171.2c1.1-0.6,1.9-1.5,2.5-2.7s0.9-2.5,0.9-4v-10c0-1.5-0.3-2.9-0.9-4s-1.4-2.1-2.5-2.7 s-2.3-0.9-3.7-0.9s-2.6,0.3-3.7,0.9s-1.9,1.5-2.5,2.7s-0.9,2.5-0.9,4v10c0,1.5,0.3,2.9,0.9,4s1.4,2.1,2.5,2.7s2.3,0.9,3.7,0.9 S761.9,171.8,763,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M788.2,142.4h4.8v34.1h-4.8V142.4z M790.6,171.9h19.5v4.5h-19.5V171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M830,175.3c-1.8-1-3.2-2.5-4.2-4.4s-1.5-4.1-1.5-6.6v-9.7c0-2.5,0.5-4.7,1.5-6.6s2.4-3.4,4.2-4.4 s3.9-1.6,6.3-1.6s4.5,0.5,6.3,1.6s3.2,2.5,4.2,4.4s1.5,4.1,1.5,6.6v9.7c0,2.5-0.5,4.7-1.5,6.6s-2.4,3.4-4.2,4.4s-3.9,1.6-6.3,1.6 S831.8,176.3,830,175.3z M840,171.2c1.1-0.6,1.9-1.5,2.5-2.7s0.9-2.5,0.9-4v-10c0-1.5-0.3-2.9-0.9-4s-1.4-2.1-2.5-2.7 s-2.3-0.9-3.7-0.9s-2.6,0.3-3.7,0.9s-1.9,1.5-2.5,2.7s-0.9,2.5-0.9,4v10c0,1.5,0.3,2.9,0.9,4s1.4,2.1,2.5,2.7s2.3,0.9,3.7,0.9 S838.9,171.8,840,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M888.5,158.1v6c0,2.5-0.5,4.8-1.5,6.7s-2.4,3.4-4.2,4.5s-3.9,1.6-6.3,1.6c-2.4,0-4.5-0.5-6.3-1.5 s-3.2-2.4-4.2-4.2s-1.5-3.9-1.5-6.3v-10.1c0-2.5,0.5-4.8,1.5-6.7s2.4-3.4,4.2-4.5s3.9-1.6,6.3-1.6c2,0,3.8,0.4,5.4,1.3 s3,2,4.1,3.6s1.9,3.3,2.2,5.3h-5.2c-0.3-1.1-0.8-2.1-1.4-2.9s-1.5-1.4-2.4-1.9s-1.8-0.6-2.8-0.6c-1.4,0-2.6,0.3-3.7,1 s-1.9,1.6-2.5,2.8s-0.9,2.6-0.9,4.2v10.1c0,1.5,0.3,2.8,0.9,3.9s1.4,2,2.5,2.6s2.3,0.9,3.8,0.9c1.4,0,2.6-0.3,3.7-0.9 s1.9-1.6,2.5-2.8s0.9-2.6,0.9-4.3v-1.5h-6.9v-4.6H888.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M910.3,176.5h-4.8v-34.1h4.8V176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M928,142.4h4.8v34.1H928V142.4z M930.3,142.4h19.6v4.5h-19.6V142.4z M930.3,157.3h17v4.5h-17V157.3z  M930.3,171.9h19.6v4.5h-19.6V171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M971.6,176.3c-1.5-0.3-2.8-0.8-4.1-1.4s-2.5-1.4-3.6-2.3l3-3.7c1.3,1.1,2.7,2,4.3,2.5s3.3,0.8,5.1,0.8 c2.5,0,4.4-0.5,5.7-1.4s2-2.2,2-3.9v0c0-1.2-0.3-2.1-0.9-2.8s-1.4-1.2-2.4-1.5s-2.2-0.6-3.8-0.9c0,0-0.1,0-0.2,0s-0.1,0-0.2,0 l-0.4-0.1c-2.3-0.4-4.1-0.8-5.6-1.3s-2.7-1.4-3.7-2.7s-1.5-3.2-1.5-5.6v0c0-2.1,0.5-3.9,1.4-5.4s2.3-2.6,4.1-3.4s4-1.2,6.5-1.2 c1.2,0,2.4,0.1,3.6,0.4s2.3,0.7,3.5,1.2s2.3,1.2,3.4,2l-2.7,3.8c-1.3-1-2.6-1.7-3.9-2.1s-2.6-0.7-3.9-0.7c-2.3,0-4.1,0.5-5.4,1.4 s-1.9,2.2-1.9,3.9v0c0,1.2,0.3,2.1,1,2.8s1.5,1.2,2.5,1.5s2.4,0.7,4.1,1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0c0.1,0,0.2,0,0.3,0 s0.2,0,0.3,0c2.1,0.4,3.8,0.9,5.2,1.5s2.5,1.5,3.5,2.8s1.4,3.1,1.4,5.3v0c0,2.1-0.5,3.9-1.5,5.3s-2.4,2.6-4.3,3.4 s-4.1,1.2-6.8,1.2C974.6,176.8,973,176.7,971.6,176.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo (1).5b475c3ce6eadc7ad75bf2eb94904711.svg";
export { ForwardRef as ReactComponent };